import { Navigate, Outlet } from 'react-router-dom'

import { useEngagementContext } from 'modules/engagement/hooks/useEngagementContext'
import { hasSurveysModule } from 'modules/engagement/lib/hasSurveysModule'
import { useMarketplaceModulesPath } from 'modules/marketplace_modules/hooks/useMarketplaceModulesPath'
import CollectionsBootstrap from 'modules/surveys/lib/CollectionsBootstrap'

const Container = () => {
  const { getListPath } = useMarketplaceModulesPath()

  const { moduleAvailabilities, upsellFlowEnabled } = useEngagementContext()

  if (!hasSurveysModule(moduleAvailabilities) && !upsellFlowEnabled) {
    return <Navigate to={getListPath()} />
  }

  return <Outlet />
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
